module.exports = __webpack_public_path__ + "img/Menu-18.1123b056.webp";